import axios from 'axios';
import { AxiosRequestConfig } from 'axios';
import {AppConfigExtended, DeviceMetrics, HeartBeat, IADPState, SoftwareUpdateStatusRequest,UpdateRequest } from '../types';
import { environment} from './util';
import { DiagnosticDataTransferReq } from '../../Types';
import { ValidationResponse } from '@npd-ng/adp-types';
const logPrefix = "[ADPClient][RequestUtil]"

const HEADER_ENAEP = {
  'Content-Type': 'application/json', 
  Authorization:  "Basic YXBwY29uZnVzZXI6QSQkYzBuZnVaYQ"
}
const PUT_HEADER = {
  'x-amz-acl': 'bucket-owner-full-control', 
  'Content-Type': 'application/json',  
}
 const PUT_HEADER_NCS = {
  'x-amz-acl': 'bucket-owner-full-control', 
  'Content-Type': 'application/octet-stream',  
}
const RequestService = {
postSoftwareUpdateInquiry : async (paylod:UpdateRequest,url:string, cb: (arg: any,arg1?: boolean) => void) =>{

    try {
        const axiosConfig:AxiosRequestConfig = {
          method: 'post',
          url:  url,
          headers: HEADER_ENAEP,
          data : paylod
        };
        
        axios(axiosConfig)
        .then(function (axiosResponse:any) {
          //console.log(axiosResponse);
          const response = {
            status:axiosResponse.status,
            ...axiosResponse.data
          }
          cb(response);
        })
        .catch(function (error:any) {
          //console.log(error);
          console.error(`[RequestService][software update][${JSON.stringify(error)}]`);
          if(error.response){
            const response = {
              status:error?.response?.status,
               ...error?.response?.data
            }
            cb(response);
          }
          else {
            console.error(`[RequestService][software update][${JSON.stringify(error)}]`);
            const response = {
              status:error?.code,
              error: {message: error.message, stack: error.stack}
            }
            cb(response);
          }
          
        });
    }
    catch(e){
      console.error(`[RequestService][validate setup code error][${JSON.stringify(e)}]`);
        cb(e, true);
    }
    },     
postSoftwareUpdateStatus: async (payload: SoftwareUpdateStatusRequest, url: string)=>{
  const promise =  new Promise<any>((resolve, reject) => {
    try {
        const axiosConfig:AxiosRequestConfig = {
          method: 'post',
          url:  url,
          headers: HEADER_ENAEP,
          data : payload
        };
        
        axios(axiosConfig)
        .then(function (axiosResponse:any) {
          const response = {
            status:axiosResponse.status,
            ...axiosResponse.data
          }
          resolve(response);
        })
        .catch(function (error:any) {
          //console.log(error);
          console.error(`[RequestService][postSoftwareUpdateStatus error][${JSON.stringify(error)}]`);
          if(error.response){
            const response = {
              status:error?.response?.status,
               ...error?.response?.data
            }
            reject(response);
          }
          else {
            console.error(`[RequestService][postSoftwareUpdateStatus error][${JSON.stringify(error)}]`);
            const response = {
              status:error?.code,
              error: {message: error.message, stack: error.stack}
            }
            reject(response);
          }
          
        });
    }
    catch(e){
      console.error(`[RequestService][postSoftwareUpdateStatus error][${JSON.stringify(e)}]`);
      reject(JSON.stringify(e));
    }  
  });
  return promise;
},
postDeviceMetrics : async (paylod:DeviceMetrics,url: string, patch: boolean, cb?: (arg: any,arg1?: boolean) => void) =>{
  const promise =  new Promise<any>((resolve) => {
  try {
      const axiosConfig:AxiosRequestConfig = {
        method: patch ? 'patch' : 'post',
        url:  url,
        headers: HEADER_ENAEP,
        data : paylod,
        timeout:15000
      };
      
      axios(axiosConfig)
      .then(function (axiosResponse:any) {
        console.log(logPrefix,`[RequestService][postDeviceMetrics] success  ${axiosResponse.status}`);
        resolve(true);
      })
      .catch(function (error:any) {
        //console.log(error);
        console.error(logPrefix,`[RequestService][postDeviceMetrics] error  ${error}`);
        if(error.response){
          resolve(false);
        }
        else {
          console.error(logPrefix,`[RequestService][postDeviceMetrics] error  ${error}`);
          resolve(false);
        }
        
      });
  }
  catch(e){
    console.error(`[RequestService][postDeviceMetrics] error  ${e}`);
    resolve(false);
  }
})
return promise;
  },
postHeartbeat : async (paylod:HeartBeat,url:string, cb?: (arg: any,arg1?: boolean) => void) =>{
  const HEADER_HB = {
    'Content-Type': 'text/plain', 
    Authorization:  "Basic YXBwY29uZnVzZXI6QSQkYzBuZnVaYQ"
  }
    try {
      //console.log(url);
        const axiosConfig:AxiosRequestConfig = {
          method: 'post',
          url:  url,
          headers: HEADER_HB,
          data : paylod
        };
        
        axios(axiosConfig)
        .then(function (axiosResponse:any) {
          //console.log(axiosResponse);
          const response = {
            status:axiosResponse.status,
            ...axiosResponse.data
          }
          if(!cb) return
          cb(response);
        })
        .catch(function (error:any) {
          //console.log(error);
          console.error(`[RequestService][heartbeat error][${JSON.stringify(error)}]`);
          if(error.response){
            const response = {
              status:error?.response?.status,
               ...error?.response?.data
            }
            if(!cb) return
            cb(response);
          }
          else {
            console.error(`[RequestService][heartbeat error][${JSON.stringify(error)}]`);
            const response = {
              status:error?.code,
              error: {message: error.message, stack: error.stack}
            }
            if(!cb) return
            cb(response);
          }
          
        });
    }
    catch(e){
      console.error(`[RequestService][heartbeat error][${JSON.stringify(e)}]`);
      if(!cb) return
        cb(e, true);
    }
    },  
checkServerStatus: async(url: string, timeout?: number)=>{
    return new Promise(async function (resolve, reject) {
      try {
        const { data, status } = await axios.get<any>(
          url,
          {
            timeout:timeout || 40000,
            headers: {
              Accept: 'application/json'
            },
          },
        );
        console.log(`[NetworkService][get request][response][url: ${url} response: ${status}]`);
        resolve({ status: status, data: data });
      } catch (err) {
        if (axios.isAxiosError(err)) {
          console.error(`[NetworkService][get request][axios error][url: ${url} response: ${err}]`);
          const error = {
            error: err.message
          }
          reject({ status: undefined, data: error });
        } else {
          console.error(`[NetworkService][get request][axios unexpected error][url: ${url} response: ${err}]`);
          const error = {
            error: 'An unexpected error occurred'
          }
          reject({ status: undefined, data: error });
        }
      }
    }
    )
},
 put : (url: string, payload:any,isOnline:boolean, timeout?:number,onProgress?:(bytes:number)=>void):Promise<any> => {

  return new Promise(async function (resolve, reject) {
    try {
      const { data, status } = await axios.put<any>(
        url,
        payload,
        {
          onUploadProgress: progressEvent => !onProgress ?  console.log("On Upload Progresss",url,progressEvent.loaded) : onProgress(progressEvent.loaded),
          timeout:timeout || 40000,
          headers: isOnline ? PUT_HEADER : PUT_HEADER_NCS,
          maxContentLength: Infinity,
          maxBodyLength: Infinity,
        },
      );
      console.log(`[NetworkService][put request][response][url: ${url} response: ${status}]`);

      resolve({ status: status, data: data });
    } catch (err) {
      if (axios.isAxiosError(err)) {
        console.error(`[NetworkService][put request][axios error][url: ${url} response: ${err}]`);
        const error = {
          error: err.message
        }
        reject({ status: undefined, data: error });
      } else {
        console.error(`[NetworkService][put request][axios unexpected error][url: ${url} response: ${err}]`);
        const error = {
          error: 'An unexpected error occurred'
        }
        reject({ status: undefined, data: error });
      }
    }
  }
  )
},
post : (url: string, payload:any,timeout?:number):Promise<any> => {

  return new Promise(async function (resolve, reject) {
    try {
      const { data, status } = await axios.post<any>(
        url,
        payload,
        {
          timeout:timeout || 10000,
          headers: {
            'Content-Type': 'application/json', 
            Authorization:  "Basic YXBwY29uZnVzZXI6QSQkYzBuZnVaYQ"
          }
        },
      );
        
      resolve({ status: status, data: data });
    } catch (err) {
      if (axios.isAxiosError(err)) {
        console.error(`[Util][post request] url: ${url} response: ${err}`);
        const error = {
          error: err.message
        }
        reject({ status: undefined, data: error });
      } else {
        console.error(`[Util][post request] url: ${url} response: ${err}`);
        const error = {
          error: 'An unexpected error occurred'
        }
        reject({ status: undefined, data: error });
      }
    }
  }
  )
},
putNCS : (url: string, payload:any) => {

  return new Promise(async function (resolve, reject) {
    try {
      const { data, status } = await axios.put<any>(
        url,
        payload,
        {
          timeout:40000,
          headers:{
            'x-amz-acl': 'bucket-owner-full-control', 
            'Content-Type': 'application/octet-stream',  
          },
          maxContentLength: Infinity,
          maxBodyLength: Infinity,
        },
      );
      console.log(`[NetworkService][post request][response][url: ${url} response: ${status}]`);

      resolve({ status: status, data: data });
    } catch (err) {
      if (axios.isAxiosError(err)) {
        console.error(`[NetworkService][post request][axios error][url: ${url} response: ${err}]`);
        const error = {
          error: err.message
        }
        reject({ status: undefined, data: error });
      } else {
        console.error(`[NetworkService][post request][axios unexpected error][url: ${url} response: ${err}]`);
        const error = {
          error: 'An unexpected error occurred'
        }
        reject({ status: undefined, data: error });
      }
    }
  }
  )
},
constructDeviceValidationDataTransferPayload:(appState:IADPState,fileName?:string)=>{
  const payload: DiagnosticDataTransferReq = {
    deliveryType: appState.sessionState.selectedAssessmentMode || "notselected" ,
    dataType:"DIAGNOSTIC",
    taskType: "UPLOAD",
    taskMessage: "Post validation logs",
    dataSubCategory: "device-validation",
    data: {
      fileName: fileName ||`${appState.appState.appLaunchId}.${appState.sessionState.selectedAssessmentMode}.device-validation.json`,
    },
    clientDetails: {
      ip: appState.sessionState.networkDetails?.address || "0.0.0.0",
      appName: `ng-enaep-student-app/${appState.deviceState.deviceType?.toLocaleLowerCase()}/p1`,
      deviceDetails: {
        deviceType: appState.deviceState.deviceType || "NPE",
        deviceName: appState.deviceState.deviceId || "NotAvailable",
      },
    },
  };
  const logHeader = {
    "schemaVersion": "1.0.1",
    "releaseVersion": appState.appState.releaseVersion,
    "buildNumber": appState.appState.releaseBuildNumber,
    "appVersion": appState.appState.appVersion,
    "appType": "npd-ng-student-app",
    "deviceDetails": {
      "deviceType": appState.deviceState.deviceType,
      "deviceName": appState.deviceState.deviceId,
      "deviceModel": appState.deviceState.deviceModel,
      "hostingPlatform": appState.appState.runtimePlatform
    },
    "sessionDetails": {
      "clientLaunchId":  appState.appState.appLaunchId,
      "adpLaunchDateTime":  appState.appState.appLaunchTime,
      "setupCode": appState.sessionState.schoolDetails?.setupCode,
      "participantId": "NotAvailable",
      "assessmentDeliveryMode": appState.sessionState.selectedAssessmentMode,
      "serverDetails": appState.connectedNCSState ? appState.connectedNCSState : environment.resolveApiDomain()
    }
  }
  return {payload,logHeader};
},
/**
 * 
 * @param appState 
 * @param fileName 
 * @param data 
 * @returns Promise
 * If playload and logHeader undefined, construct the request from current app state values
 * Logs that stored from previous sessions shall come with predefined payload and logHeader
 */
postValidationLogs: (appState:IADPState,fileName:string,data: {payload:DiagnosticDataTransferReq,logHeader:any},responses?:ValidationResponse[],config?:AppConfigExtended)=> new Promise<boolean>((resolve)=>{
  const _getRequestPayload=()=>{
    
    if(responses){
      if(data.payload && data.logHeader && appState.deviceReadinessSummary){
        return {...data,deviceValidationChecks:{deviceName:appState?.deviceReadinessSummary?.deviceName, status:appState?.deviceReadinessSummary?.status,responses:responses}}
      }
      else{
        const {payload,logHeader} = RequestService.constructDeviceValidationDataTransferPayload(appState,fileName);
        return {
            payload:payload,
            logHeader:logHeader,
            deviceValidationChecks:{deviceName:appState?.deviceReadinessSummary?.deviceName, status:appState?.deviceReadinessSummary?.status,responses:responses}
          }
      }
    }
    else{
      if(data.payload && data.logHeader){
        return {...data,deviceValidationChecks:appState.deviceReadinessSummary}
      }
      else {
      const {payload,logHeader} = RequestService.constructDeviceValidationDataTransferPayload(appState,fileName);
      return {
          payload:payload,
          logHeader:logHeader,
          deviceValidationChecks:appState.deviceReadinessSummary
      }
      }
    }
  }
  const {deviceValidationChecks, logHeader,payload}  = _getRequestPayload();
  const getSignedUrl=(url:string, payload:DiagnosticDataTransferReq,cb: any)=>{
    const response = RequestService.post(url,payload);
    response.then((response: any) => {
      if(response.status === 200) cb(response.data.dataUri)
    }).catch((e:any) => {
      console.error(`[getSignedUrl not available: ${JSON.stringify(e)}`);
      cb(false)
    })
  }
  const onSignedUrl = async (response:any)=>{
    if(response){
      RequestService.put(response,
        {...logHeader,deviceValidationChecks:deviceValidationChecks},appState.sessionState.selectedAssessmentMode ==="online").then(()=>{
        resolve(true);
      }).catch((err:any)=>{
        console.error("An error occurred trying to send the device validation log.",err);
        resolve(false)
      })
    }
    else{
      resolve(false);
    }
  };
  const onlineServiceConfig = appState.appState.configuration?.onlineServices || config?.onlineServices;
  let url: string | undefined =`${environment.resolveApiDomain()}/${onlineServiceConfig?.dataTransfer.sign}`;
  if(appState.sessionState.selectedAssessmentMode ==="ncs"){
    url= appState.connectedNCSState?.config?.adminServices?.dataTransferUrl;
  }
  if(url)getSignedUrl(url,payload,onSignedUrl);
}) 
  };
export default RequestService;